const VERSION_UPDATE = 'VERSION_UPDATE';

export const initialState = {
	appVersion: {}
};

export function versionUpgrade(upgrade) {
	return {
		type: VERSION_UPDATE,
		upgrade
	};
}

export default function reducer(state = initialState.appVersion, action) {
	switch (action.type) {
		case VERSION_UPDATE:
			return {upgrade: action.upgrade, version: action.version};
		default:
			return state;
	}
}
